import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import {
    LocationInfo,
    LocationService,
} from '../shared/services/location.service';
import { inject } from '@angular/core';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap, tap } from 'rxjs';

export interface LocationState {
    locationInfo: LocationInfo | null;
    isLoading: boolean;
    error: string | null;
}

export const initialLocationState: LocationState = {
    locationInfo: null,
    isLoading: false,
    error: null,
};

export const LocationStore = signalStore(
    { providedIn: 'root' },
    withState(initialLocationState),
    withMethods((store, locationService = inject(LocationService)) => ({
        // Method to trigger the fetch
        loadLocation: rxMethod<void>(
            pipe(
                tap(() => patchState(store, { isLoading: true, error: null })), // Start loading
                switchMap(() => {
                    return locationService.getUserLocation().pipe(
                        tap({
                            next: (locationInfo) => {
                                if (
                                    locationInfo &&
                                    locationInfo.status === 'success'
                                ) {
                                    patchState(store, {
                                        locationInfo,
                                        isLoading: false,
                                    }); // Success
                                } else {
                                    patchState(store, {
                                        isLoading: false,
                                        error:
                                            locationInfo?.message ||
                                            'Failed to retrieve location details.',
                                    }); // API Error
                                }
                            },
                            error: (error) => {
                                patchState(store, {
                                    isLoading: false,
                                    error: 'Could not connect to location service.',
                                }); // HTTP Error
                            },
                        })
                    );
                })
            )
        ),
        // Method to clear location state (e.g., on logout)

        clearLocationState(): void {
            patchState(store, initialLocationState);
        },
    }))
);
